import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule, MatDialog } from '@angular/material/dialog';
import { PlanProtectionService } from '../../../app/service/plan-protection/plan-protection.service';
import { environment } from '../../../environments/environment';
import { SuccessDialogComponent } from '../success-dialog/success-dialog.component';
import { SpinnerService } from '../../../app/service/spinner-service/spinner.service';
import { ErrorDialogComponent } from '../error-dialog/error-dialog.component';

@Component({
  selector: 'app-servicios-seleccionados-dialog',
  templateUrl: './servicios-seleccionados-dialog.component.html',
  styleUrl: './servicios-seleccionados-dialog.component.scss'
})
export class ServiciosSeleccionadossModalComponent {

  title = ''
  carrito = []
  ppDetalle: any
  tieneServicios = false
  step = 1
  base64Placas
  base64NoSerie
  base64Ine
  base64Firma
  base64Tacometro
  kilometraje 
  isCameraReady = false

  constructor(
    public dialogRef: MatDialogRef<ServiciosSeleccionadossModalComponent>,
    private ppService: PlanProtectionService,
    private spinnerService: SpinnerService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.title = data.title
    this.carrito = data.carrito
    this.ppDetalle = data.ppDetalle
    this.kilometraje = data.kilometraje
    this.base64Tacometro = data.base64Tacometro
    this.carrito.forEach(element => {
      if(element.serviciosSeleccionados.length > 0){
        this.tieneServicios = true
        return
      }
    });
  }

  closeDialog(){
    this.dialogRef.close({event: 2})
  }

  nextStep(){
    this.step ++
  }

  backStep(){
    this.step --
  }

  async redimirServicios(){
    this.spinnerService.setMensaje('Redimiendo Servicios...')
    this.spinnerService.show()
    let body = {
      ordenVentaPlanProtectionId: this.ppDetalle.ordenVentaPlanProtectionId,
      ordenVentaId: this.ppDetalle.ordenVentaId,
      folio: this.ppDetalle.folio,
      empresaId: parseInt(localStorage.getItem('sucursal_empresa_id')),
      userName:  localStorage.getItem('userName'), 
      sucursalId:  parseInt(localStorage.getItem('sucursal_id')), 
      empresaReferenciaId: this.ppDetalle.empresaId,
      sucursalReferenciaId: this.ppDetalle.sucursalId,
      img_ine: "img_ine",
      img_placas: "img_placas",
      // img_noSerie: "img_noSerie",
      img_tacometro: "img_tacometro",
      kilometraje: parseInt(this.kilometraje),
      img_firma: "img_firma",
      usuarioId: localStorage.getItem('id'),
      llantas: []
    }
    const auxC = structuredClone(this.carrito);
    let auxCarrito = []
    auxC.forEach(element => {
      if(element.serviciosSeleccionados.length > 0){
        auxCarrito.push({
          llantaId: element.llantaId,
          serviciosSeleccionados: element.serviciosSeleccionados
        })
      }
    });
    body['llantas'] = auxCarrito
    let formData = new FormData()
    let auxGarantia = []

    body.llantas.forEach((element, index) => {
      element.serviciosSeleccionados.forEach(element2 => {
        if(element2.servicioSkuId === environment.garantiaServicioId){
          auxGarantia.push({...element2, llantaId: element.llantaId})
          element2['img_danio'] = 'img_danio_llanta'+element.llantaId
          element2['img_piso'] = 'img_piso_llanta'+element.llantaId
          element2['img_perfil'] = 'img_perfil_llanta'+element.llantaId
        }
      });
    });

    auxGarantia.forEach(async element => {
      let img_danio = await this.base64ToBlob(element.img_danio, 'image/png')
      let img_perfil = await this.base64ToBlob(element.img_perfil, 'image/png')
      let img_piso = await this.base64ToBlob(element.img_piso, 'image/png')

      formData.append('img_danio_llanta' + element.llantaId, img_danio, 'img_danio_llanta' + element.llantaId + '.png');
      formData.append('img_perfil_llanta' + element.llantaId, img_perfil, 'img_perfil_llanta' + element.llantaId + '.png');
      formData.append('img_piso_llanta' + element.llantaId, img_piso, 'img_piso_llanta' + element.llantaId + '.png');
    });
    
    
    formData.append("datos", JSON.stringify(body));

    let img_ine = await this.base64ToBlob(this.base64Ine, 'image/png')
    let img_placas = await this.base64ToBlob(this.base64Placas, 'image/png')
    let img_firma = await this.base64ToBlob(this.base64Firma, 'image/png')
    let img_tacometro = await this.base64ToBlob(this.base64Tacometro, 'image/png')

    formData.append('img_tacometro', img_tacometro, 'img_kilometraje.png');
    formData.append('img_placas', img_placas, 'img_placas.png');
    formData.append('img_ine', img_ine, 'img_ine.png');
    formData.append('img_firma', img_firma, 'img_firma.png');

    formData.forEach((valor, clave) => {
      // console.log(clave, valor);
    });
    await this.ppService.redimirServiciosGarantias(formData).subscribe(
      data => {
        if(data.code === 200){
          let mensaje = data.ordenVentaId !== undefined ? 'Se redimieron correctamente los servicios. <br> OV: ' + data.ordenVentaId : 'Se redimieron correctamente los servicios.'
          const dialogRef = this.dialog.open(SuccessDialogComponent, {
            panelClass: 'custom-dialog',
            disableClose: true,
            width: '100vw',
            height: 'auto',
            maxHeight: '720px',
            data: {
              mensaje: mensaje 
            }
          });
          this.dialogRef.close({event: 1})
          this.spinnerService.hide()
        }
        
        if(data.code === 400 || data.code === 500){
          const dialogRef = this.dialog.open(ErrorDialogComponent, {
            panelClass: 'custom-dialog',
            disableClose: true,
            width: '100vw',
            height: 'auto',
            maxHeight: '720px',
            data: {
              isError: true,
              message: data.message
            }
          });
          this.dialogRef.close({event: 4})
        }
      }
    )
  }

  onImage(event: { image: string; opcion: number }): void {
    if(event.image === 'data:,'){
      this.desactivarContinuar(event)
    }else{
      if(event.opcion === 1){
        this.base64Placas = event.image
      }else if(event.opcion === 2){
        this.base64NoSerie = event.image
      }else{
        this.base64Ine = event.image
      }
    }
  }

  camaraInicializada(event){
    this.isCameraReady = event.inicializada
  }

  desactivarContinuar(event: { opcion: number }): void {
    if(event.opcion === 1){
      this.base64Placas = undefined
    }else if(event.opcion === 2){
      this.base64NoSerie = undefined
    }else{
      this.base64Ine = undefined
    }
  }
  
   onSignature(dataUrl: string): void {
    this.base64Firma = dataUrl
    // this.tieneFirma = true
  }

  limpiarFirma(){
    // this.tieneFirma = false
    this.base64Firma = undefined
  }

  getDisabled(){
    if(this.step === 1){
      return false
    }else if(this.step === 2){
      return this.isCameraReady ? this.base64Placas !== undefined ? false : true : true
    }else if(this.step === 3){
      return this.isCameraReady ? this.base64Ine !== undefined ? false : true : true
    }else if(this.step === 4){
      return this.isCameraReady ? this.base64Firma !== undefined ? false : true : true
    }else{
      return false
    }
  }

  getTitle(){
    if(this.step === 1){
      return this.title
    }else if(this.step === 2){
      return 'Captura de Placas'
    }else if(this.step === 3){
      // return 'Captura de Tacómetro'
      return 'Captura de Identificación Oficial'
    }else{
      return 'Captura de Firma'
    }
  }

  soloNumeros(event: KeyboardEvent): void {
    const teclasPermitidas = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'];
    const esNumero = /^[0-9]$/.test(event.key);

    if (!esNumero && !teclasPermitidas.includes(event.key)) {
      event.preventDefault();
    }
  }

  limpiarCaracteresNoNumericos(event: Event): void {
    const input = event.target as HTMLInputElement;
    // Elimina cualquier carácter que no sea número
    input.value = input.value.replace(/[^0-9]/g, '');
  }

  base64ToBlob(base64, mimeType) {
    const byteCharacters = atob(base64.split(',')[1]);
    const byteArrays = [];

    for (let i = 0; i < byteCharacters.length; i++) {
      byteArrays.push(byteCharacters.charCodeAt(i));
    }

    const byteArray = new Uint8Array(byteArrays);
    return new Blob([byteArray], { type: mimeType });
  }
}